import { render } from "./HomeAdmin.vue?vue&type=template&id=6b1894aa"
import script from "./HomeAdmin.vue?vue&type=script&lang=js"
export * from "./HomeAdmin.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__